// ============================================================================
//  hoopLibrary — katalog koszy (hoops.json), lustrzane odbicie tileLibrary.
//
//  Model danych: `default` (id startowego kosza), `hoops` (id, name, thumb,
//  model, transform, hide). `model` to ścieżka do pliku GLB; `transform`
//  (scale/yaw/position) wyrównuje obręcz do RIM_CENTER, a `hide` listuje nazwy
//  materiałów do ukrycia (statyczna siatka z modelu). Pola te interpretuje
//  loader (objects/hoops/glbHoop.js + prepareHoop.js), nie schemat globalny.
//  Ścieżki w JSON są względne do katalogu publicznego; prefiksujemy BASE_URL.
// ============================================================================

// Wczytaj katalog koszy (JSON). BASE_URL czytany wewnątrz funkcji, by import
// modułu działał też poza Vite (testy node nie mają import.meta.env).
export async function loadHoopCatalog() {
  const base = import.meta.env.BASE_URL || '/'
  const res = await fetch(`${base}hoops/hoops.json`)
  if (!res.ok) throw new Error(`Nie można wczytać hoops.json (HTTP ${res.status})`)
  return res.json()
}

// Kosz po id (z fallbackiem do pierwszego) — jak resolveModel w tileLibrary.
export function resolveHoop(catalog, id) {
  return catalog.hoops.find((h) => h.id === id) || catalog.hoops[0]
}
